import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from 'styled-components';
import { marginAttributes, paddingAttributes, sizeAttributes } from '../../system/attributes';
import { getPropsBlocker } from '../../utils';
import { spacing } from '../../system/mixins';
export var DataTableRoot = styled.div.withConfig(getPropsBlocker())(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n\n    ", "\n    ", "\n    ", "\n"])), sizeAttributes, paddingAttributes, marginAttributes);
export var DataTableFooter = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n    display: flex;\n    justify-content: flex-end;\n"])), spacing(3));